import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    "model-value": _ctx.humanValue,
    placeholder: _ctx.actualPlaceholder,
    mask: _ctx.mask
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _ctx.onInput,
    onFocus: _ctx.open
  }), null, 16, ["model-value", "placeholder", "mask", "onUpdate:modelValue", "onFocus"]))
}